import { REGEXP } from 'shared/consts/regExp'
import * as yup from 'yup'

export const artistFormRules = {
  name: { required: 'Artist Name is required.' },
  label_id: { required: 'Label is required.' },
  opus_id: { pattern: { value: REGEXP.OPUS_ID, message: 'Please use Opus ID in format GRP-xxxxxx' } }
}

export const artistFormSchema = yup.object().shape({
  name: yup.string().required('Artist Name is required.'),
  label_id: yup.string().required('Label is required.'),
  opus_id: yup.string().notRequired().test('opus_id', 'Please use Opus ID in format GRP-xxxxxx', function(opusId) {
    if (opusId) {
      const schema = yup.string().matches(REGEXP.OPUS_ID)
      return schema.isValidSync(opusId)
    }
    return true
  }),
  spotify_url: yup.string()
    .when('opus_id', {
      is: (opusId: number) => !!opusId,
      then: yup.string().notRequired().test('spotify_url', 'Please use Spotify Url in format https://open.spotify.com/artist/xxxxxx', function(value) {
        if (value) {
          const schema = yup.string().matches(REGEXP.SPOTIFY_URL)
          return schema.isValidSync(value)
        }
        return true
      }),
    })
})
